import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Switch from 'flarum/common/components/Switch';
export default function hideLinkPreviewsSetting() {
  extend('flarum/forum/components/SettingsPage', 'privacyItems', function (items) {
    const user = app.session.user;
    if (!user) return;
    items.add('hideLinkPreviews', m(Switch, {
      state: Boolean(user.preferences()?.hideLinkPreviews),
      loading: Boolean(this.hideLinkPreviewsLoading),
      onchange: hide => save(this, hide)
    }, app.translator.trans('datlechin-link-preview.forum.settings.hide_link_previews_label'), m("span", {
      className: "helpText"
    }, app.translator.trans('datlechin-link-preview.forum.settings.hide_link_previews_help'))), 90);
  });
}
function save(page, hide) {
  const user = app.session.user;
  if (!user) return;
  page.hideLinkPreviewsLoading = true;
  user.savePreferences({
    hideLinkPreviews: hide
  }).catch(() => undefined).then(() => {
    page.hideLinkPreviewsLoading = false;
    m.redraw();
  });
}